import { connect } from 'react-redux';
import { compose, mapProps } from 'recompose';
import { debounce } from 'lodash';

import { setTextSearch } from 'modules/queues/Archive/actions/archiveAppointmentsFilters';
import { TextSearch } from 'modules/queues/common/components/AppointmentsFilter';


export default compose(
  connect(
    state => ({ textSearch: state.queues.archive.archiveAppointmentsFilters.textSearch }),
    { setTextSearch },
  ),

  mapProps(({ setTextSearch, ...rest }) => ({
    ...rest,
    setTextSearch: debounce(setTextSearch, 1000),
  })),
)(TextSearch);
